import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=209e8516&scoped=true&"
import script from "./Email.vue?vue&type=script&lang=ts&"
export * from "./Email.vue?vue&type=script&lang=ts&"
import style0 from "./Email.vue?vue&type=style&index=0&id=209e8516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209e8516",
  null
  
)

export default component.exports